import React from 'react';
import { Camera } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { LISTING_PHOTO_PENDING_TEST_ID } from '../lib/listingPhotoDisplay';

export default function ListingPhotoPending({ className = '' }) {
  const { t } = useLanguage();

  return (
    <div
      className={`flex flex-col items-center justify-center bg-gradient-to-br from-slate-100 via-slate-50 to-signal-blue/10 border border-slate-200 text-center px-6 ${className}`}
      data-testid={LISTING_PHOTO_PENDING_TEST_ID}
      role="img"
      aria-label={t('listing.photo_pending.aria', 'Owner-supplied listing photo pending')}
    >
      <div className="w-14 h-14 rounded-full bg-white border border-slate-200 shadow-sm flex items-center justify-center mb-3">
        <Camera className="w-7 h-7 text-signal-blue" aria-hidden="true" />
      </div>
      <p className="text-sm font-semibold text-slate-800 tracking-wide">
        {t('listing.photo_pending.title', 'Owner photo pending')}
      </p>
      <p className="text-xs text-slate-500 mt-1 max-w-[16rem]">
        {t('listing.photo_pending.subtitle', 'Real listing imagery will appear once the owner provides approved photos.')}
      </p>
    </div>
  );
}
